import { Directory } from 'app/_shared/tree/directory';

export class RequestFolder {
  public mapFolders(data: any[]) {
    const res = [];
    const helper = [];
    // First level of folders
    data.forEach((element) => {
      if (!element.requestFolderParentUniqueCode) {
        res.push(new Directory(element.requestFolderTitle, [], element.requestFolderUniqueCode));
      } else {
        helper.push(element);
      }
    });

    // second level of folders
    helper.forEach((element) => {
      res.forEach((dir: Directory) => {
        if (dir.code === element.requestFolderParentUniqueCode) {
          dir.directories.push(new Directory(element.requestFolderTitle, [], element.requestFolderUniqueCode));
        }
      });
    });

    // third level of folders
    res.forEach((dir: Directory) => {
      helper.forEach((element) => {
        dir.directories.forEach((childDir: Directory) => {
          if (childDir.code === element.requestFolderParentUniqueCode) {
            childDir.directories.push(new Directory(element.requestFolderTitle, [], element.requestFolderUniqueCode));
          }
        });
      });
    });

    return res;
  }
}
